import { render, staticRenderFns } from "./CarouselPromoModule.vue?vue&type=template&id=b797fd04&"
import script from "./CarouselPromoModule.ts?vue&type=script&lang=ts&"
export * from "./CarouselPromoModule.ts?vue&type=script&lang=ts&"
import style0 from "./CarouselPromoModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports